import { useTheme } from '@mui/material/styles';

export const useInfoCardStyles = () => {
  const theme = useTheme();
  return {
    heading: {
      color: '#202020',
      backgroundColor: theme.palette.secondary.main,
    },
    headerSpace: {
      justifyContent: 'space-between',
    },
    headerStart: {
      justifyContent: 'flex-start',
    },
    icon: {
      color: theme.palette.primary.main,
    },
    card: {
      border: 'none',
      boxShadow: 'none',
    },
  };
};
